import { defineComponent as _defineComponent } from 'vue'
import AdminNavigation from "../../AdminNavigationContainer.vue";
import { ref, onMounted, reactive, onUpdated } from "vue";
import NewsMailDataService from "@/services/NewsMailDataService.ts";
import ResponseData from "@/types/ResponseData";
import Loading from "@/components/home/Loading.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import { store } from "@/store/store";
import { useI18n } from "vue3-i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("");
const alertState = ref("");
const menuTitle = ref("News Mail Maintenance");
const i18n = useI18n();
const newsMailUserList = reactive([]);
const errormessage = ref("");
const userId = ref("");
const delDataId = ref("");

onMounted(() => {
  isLoading.value = true;
  getNewsMailUserList();
});

onUpdated(function () {
  var tableHeight = 0;
  var dataHeight = document.getElementById("tbodyNewsMailBody")?.clientHeight;
  if (dataHeight != 0) {
    tableHeight = document.getElementById("divNewsMailBody")?.clientHeight;
    if (dataHeight > tableHeight) {
      document.getElementById("divNewsMailBody").style.width = "100%";
    } else {
      document.getElementById("divNewsMailBody").style.width = "calc(100% - 16px)";
    }
  }
});

const getNewsMailUserList = () => {
  newsMailUserList.splice(0);
  var data = {
    mainMenuCode: store.getters.mainMenuCode
  }
  NewsMailDataService.getNewsMailUserList(data).then((response: ResponseData) => {
    if (response.data) {
      newsMailUserList.splice(0);
      if (response.data.newsMailUserList != undefined) {
        newsMailUserList.push(response.data.newsMailUserList);
        newsMailUserList[0].sort(function (firstObj: { givenName: string; }, secondObj: { givenName: any; }) {
          return firstObj.givenName.localeCompare(secondObj.givenName)
        });
      }
    }
    isLoading.value = false;
  }).catch((error: ResponseData) => {
    errormessage.value = error.response.data.message;
    isLoading.value = false;
  });
};

const onClickAddButton = () => {
  alertMessage.value = "null";
  alertState.value = "neutral";
  errormessage.value = "";
  const data = {
    userId: userId.value,
    destCode: store.getters.mainMenuCode,
    loginUserId: store.getters.cognitoUserName
  };

  if (userId.value.trim() == "") {
    errormessage.value = "※Please enter user ID";
    isLoading.value = false;
  } else {
    errormessage.value = "";
    NewsMailDataService.addNewsMailUser(data)
      .then((_) => {
        alertMessage.value = i18n.t("suc039");
        alertState.value = "success";
        isLoading.value = false;
        getNewsMailUserList();
      })
      .catch((error: ResponseData) => {
        errormessage.value = error.response.data.message;
        isLoading.value = false;
      });
  }
};

const setDeleteUser = (userInfo: any) => {
  delDataId.value = userInfo.id;
}

const onClickDeleteButton = () => {
  document.getElementById("deleteCancel")?.click();
  alertMessage.value = "null";
  alertState.value = "neutral";
  const data = { delDataId: delDataId.value };
  NewsMailDataService.deleteNewsMailUser(data).then((_) => {
    alertMessage.value = i18n.t("suc003");
    alertState.value = "success";
    isLoading.value = false;
    if (newsMailUserList.length > 0) {
      const indexVal0 = newsMailUserList[0].findIndex((objVal: any) => { return objVal.id == data.delDataId; });
      if (indexVal0 != -1) {
        newsMailUserList[0].splice(indexVal0, 1);
      }
    }
  }).catch((error: ResponseData) => {
    errormessage.value = error.response.data.message;
    isLoading.value = false;
  });;
};

const __returned__ = { isLoading, alertMessage, alertState, menuTitle, i18n, newsMailUserList, errormessage, userId, delDataId, getNewsMailUserList, onClickAddButton, setDeleteUser, onClickDeleteButton, AdminNavigation, Loading, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})